import { render } from "./DeleteLocal.vue?vue&type=template&id=a60d4d4e&scoped=true"
import script from "./DeleteLocal.vue?vue&type=script&lang=js"
export * from "./DeleteLocal.vue?vue&type=script&lang=js"

import "./DeleteLocal.vue?vue&type=style&index=0&id=a60d4d4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a60d4d4e"

export default script